
/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'sites': {
    width: 18,
    height: 19,
    viewBox: '0 0 18 19',
    data: '<path fill-rule="evenodd" clip-rule="evenodd" d="M8.62775 0.200467C8.84434 0.0760072 9.08869 0 9.35273 0C9.61677 0 9.86111 0.0760072 10.0777 0.200467L17.0016 4.26349C17.4592 4.54231 17.7714 5.05923 17.7714 5.65729V15.0974C17.7714 15.9905 17.0864 16.7138 16.2407 16.7138V5.65729H2.46473V16.7138C1.61904 16.7138 0.934067 15.9905 0.934067 15.0974V5.65729C0.934067 5.05923 1.24621 4.54231 1.70388 4.26349L8.62775 0.200467ZM3.9954 9.69821V7.27365H14.7101V9.69821H10.1181C10.1181 9.25209 9.77519 8.89002 9.35273 8.89002C8.93026 8.89002 8.58739 9.25209 8.58739 9.69821H3.9954Z"/>'
  }
})
